import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

@connect((store) => {
    return { 
        isKaiserMember: store.user.isKaiserMember,
        date: store.meta.date.getDay()
    };
})
class Novato extends React.Component {
    constructor(props) {
        super(props);
        this.goToNavatoInfo = this.goToNavatoInfo.bind(this);
        this.goToHuckleberry = this.goToHuckleberry.bind(this);
        this.goToHuckleberryInfo = this.goToHuckleberryInfo.bind(this);
        this.goToFpact = this.goToFpact.bind(this);
    }
    
    goToNavatoInfo() {
        this.props.history.push('/location?id=novatoMonday');
    }

    goToHuckleberry() {
        this.props.history.push('/huckleberry');
    }

    goToHuckleberryInfo() {
        this.props.history.push('/location?id=huckleberry');
    }

    goToFpact() {
        this.props.history.push('/fpact');
    }

    render() {
        console.log('the date is ' + this.props.date);

        let topText = null;
        let bottomText = null;
        let yesButton = null;
        let noButton = null;

        let testDate = 4;

        //TODO cleanup this code with components
        switch(this.props.date) {
            case 6: //sat
                console.log('it is Saturday');
                topText = 'There is a Monday Teen Clinic at the Novato Wellness Center from 1:30pm - 5pm. You can get EC for FREE there.';
                bottomText = 'Are you able to wait and make it to Novato on Monday?';
                yesButton = <button className="ec__button" onClick={this.goToNavatoInfo}>Yes</button>;
                noButton = <a className="ec__button" onClick={this.goToFpact}>No</a>;
                break;
            case 0: //sun
                console.log('it is Sunday');
                topText = 'Tomorrow is the Monday Teen Clinic at the Novato Wellness Center from 1:30pm - 5pm. You can get EC for FREE there.';
                bottomText = 'Are you able to wait and make it to Novato tomorrow?';
                yesButton = <button className="ec__button" onClick={this.goToNavatoInfo}>Yes</button>;
                noButton = <button className="ec__button" onClick={this.goToHuckleberry}>No</button>;
                break;
            case 1: //mon
                console.log('it is Monday');
                topText = 'Today is the Monday teen clinic from 1:30pm - 5pm at the Novato Wellness Center. You can get EC for FREE there.';
                bottomText = 'Are you able to make it to Novato by 4PM?';
                yesButton = <button className="ec__button" onClick={this.goToNavatoInfo}>Yes</button>;
                noButton = <button className="ec__button" onClick={this.goToHuckleberry}>No</button>;
                break;
            case 2: //tue
                console.log('it is Tuesday');
                topText = 'Today is Huckleberry’s Teen Tuesday Clinic from 1 - 5pm. You can get EC for FREE there.';
                bottomText = 'Are you able to make it to San Rafael by 4pm?'
                yesButton = <button className="ec__button" onClick={this.goToHuckleberryInfo}>Yes</button>;
                noButton = <button className="ec__button" onClick={this.goToFpact}>No</button>;
                break;
            default:
                this.props.history.push('/fpact');
        }

        return (
            <div>
                <div className="row justify-content-md-center">
                    <div className="col-md-6">
                        <p className="ec__font__body text-center">
                            {topText}
                        </p>

                        <h1 className="ec__font__title text-center">
                            {bottomText}
                        </h1>

                        <p className="ec__font__body text-center ec__font__body--small">
                            You can get a confidential pass from school, if needed.
                        </p>
                    </div>
                </div>

                <div className="choices choices--small row">
                    <div className="col text-center">
                        {yesButton}
                    </div>
                    <div className="col text-center">
                        {noButton}
                    </div>
                </div>
            </div>
        )
    }
}

export default Novato;


// WEBPACK FOOTER //
// ./src/components/screens/Novato.js